export enum ORIGINAL_APP_TYPE_IDS {
  COMPANY_POLICIES = 249,
  EMPLOYMENT_CONTRACTS = 566,
}

export const DISABLED_FIELD_CODES_BY_APP_TYPE: Record<string, string[]> = {
  business_trip_reports: [
    "ステータス",
    "status",
    "application_creator",
    "application_approver",
  ],
  // business_flowcharts: ["カテゴリ", "ステータス"],
};
export const PREFIX_CLASS_ROW = "row-";
